import React from 'react'

const AddTips = function ({ type = 'subAccount', isTable }) {
  // type subAccount invite
  return (
    <div
      className="w-full py-3 px-4 text-gray-600 flex flex-row rounded-box"
      style={{
        background: 'var(--ow-bg-comps-color)',
        fontSize: '0.75rem',
      }}
    >
      {type === 'subAccount' ? (
        <div className="flex-1">
          {isTable ? (
            <>
              <p className="mt-1">
                <b className="mr-1">1.</b>用户姓名不能超过40字符
              </p>
              <p className="mt-1">
                <b className="mr-1">2.</b>用户名需由2-16位数字或字母组成
              </p>
              <p className="mt-1">
                <b className="mr-1">3.</b>
                用户密码至少8个字符，不超过16个字符，必须包含符号、数字和字母中的两种
              </p>
            </>
          ) : (
            <>
              <p>
                <b className="mr-1">1.</b>
                请按照正确格式添加用户，字段中间以“逗号”隔开，添加多个用户时需要换行输入
              </p>
              <p className="mt-1">
                <b className="mr-1">2.</b>用户姓名不能超过40字符
              </p>
              <p className="mt-1">
                <b className="mr-1">3.</b>用户名需由2-16位数字或字母组成
              </p>
              <p className="mt-1">
                <b className="mr-1">4.</b>
                用户密码至少8个字符，不超过16个字符，必须包含符号、数字和字母中的两种
              </p>
              <p className="mt-1">
                <b className="mr-1">5.</b>手机号必须符合手机格式
              </p>
            </>
          )}
        </div>
      ) : (
        <div className="flex-1" style={{ opacity: '0.85' }}>
          <p>
            <b className="mr-1">1.</b>
            请按照正确格式添加用户，字段中间以“逗号”隔开，添加多个用户时需要换行输入
          </p>
          <p className="mt-1">
            <b className="mr-1">2.</b>用户姓名不能超过40字符
          </p>
          <p className="mt-1">
            <b className="mr-1">3.</b>
            平台将为未注册的用户发送邀请短信，用户成功注册后直接添加到本项目
          </p>
        </div>
      )}
    </div>
  )
}

export default AddTips
